import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

// -> General
import auth from './auth'
import user from './user'
import schedules from './schedules'
import appointments from './appointments'
import reports from './reports'

// -> Clinic
import clinicProfile from './clinicProfile'
import professionals from './professionals'

// -> Laboratory
import laboratoryProfile from './laboratoryProfile'

// -> Professional
import professionalProfile from './professionalProfile'

const rootReducer = history =>
  combineReducers({
    // -> General
    router: connectRouter(history),
    auth,
    user,
    schedules,
    appointments,
    reports,

    // -> Clinic
    clinicProfile,
    professionals,

    // -> Laboratory
    laboratoryProfile,

    // -> Professional
    professionalProfile
  })

export default rootReducer
